import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let productResearchLogsMountPromise = null;

export function initProductResearchLogsViewFragment({ onMounted } = {}) {
  registerViewMount('admin-product-research-logs', () => mountProductResearchLogsView(onMounted));
}

async function mountProductResearchLogsView(onMounted) {
  if (document.getElementById('view-admin-product-research-logs')) return;
  if (productResearchLogsMountPromise) return productResearchLogsMountPromise;

  productResearchLogsMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/product-research-logs.html', 'Unable to load product research logs view');
    onMounted?.();
  })();

  try {
    await productResearchLogsMountPromise;
  } catch (error) {
    productResearchLogsMountPromise = null;
    throw error;
  }
}
